module.exports = __webpack_public_path__ + "static/media/1_WEB_BELV_Vue-Ext.94561c19.jpg";